var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'formCheckbox',
    {
      'formCheckbox--medium': _vm.isMedium,
      'formCheckbox--smallError': _vm.smallError,
      'formCheckbox--reverse': _vm.isReverse,
    },
  ]},[_c('input',{staticClass:"formCheckbox__input",attrs:{"id":_vm.id,"name":_vm.name,"type":"checkbox","disabled":_vm.disabled,"required":_vm.required},domProps:{"value":_vm.value,"checked":_vm.checkboxState},on:{"change":_vm.toggle}}),_vm._v(" "),_c('label',{staticClass:"formCheckbox__label",attrs:{"for":_vm.id}},[_c('div',{staticClass:"formCheckbox__check"}),_vm._v(" "),_c('div',{staticClass:"formCheckbox__text"},[(_vm.hasHtml)?_c('div',[_vm._t("default")],2):_c('div',[_vm._v("\n        "+_vm._s(_vm.label)+"\n      ")]),_vm._v(" "),(_vm.available)?_c('span',{staticClass:"formCheckbox__textNumber"},[_vm._v("("+_vm._s(_vm.available)+")")]):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }